import { useState, useRef, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { Navbar } from "../../../components/Navbar/Navbar";
import { Footer } from "../../../components/Footer/Footer";
import { Banner } from "../../../components/Banner/Banner";
import topImage from "../../../assets/images/BannerTop.png";
import X from "../../../assets/images/galleryWriteX.png";
import "./GalleryWrite.css";

export const GalleryEdit = () => {
    const BOARD_URL = process.env.REACT_APP_BOARD_API_URL || 'http://localhost:5001';
    const { id } = useParams();
    const navigate = useNavigate();
    
    // 상태 관리
    const [title, setTitle] = useState("");
    const [content, setContent] = useState(""); // 내용 상태
    const [currentImageUrl, setCurrentImageUrl] = useState(""); 
    const [file, setFile] = useState(null); 
    const [preview, setPreview] = useState(null); 

    const fileInputRef = useRef(null);

    // 1. 페이지 로드 시 기존 데이터 불러오기 (여기가 중요합니다!)
    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            alert("로그인이 필요합니다.");
            navigate('/adLogin');
            return;
        }

        const fetchGallery = async () => {
            try {
                const res = await fetch(`${BOARD_URL}/gallery/${id}`);
                if (!res.ok) throw new Error("데이터를 불러올 수 없습니다.");
                
                const data = await res.json();
                
                // 받아온 데이터를 상태(State)에 넣어줍니다.
                setTitle(data.title);           // 제목 채우기
                setContent(data.content || ""); // ✅ [핵심] 내용 채우기 (없으면 빈 문자열)
                setCurrentImageUrl(data.imageUrl); // 기존 이미지 경로 저장
                
            } catch (err) {
                console.error(err);
                alert("존재하지 않는 게시물입니다.");
                navigate('/gallery');
            }
        };

        fetchGallery();
    }, [id, navigate, BOARD_URL]);

    // 2. 새 이미지 선택 핸들러
    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
            setPreview(URL.createObjectURL(selectedFile));
        }
    };

    const triggerFileInput = () => {
        fileInputRef.current.click();
    };

    const handleRemoveNewImage = () => {
        setFile(null);
        setPreview(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };

    // 3. 수정 완료 핸들러
    const handleUpdate = async () => {
        if (!title.trim()) {
            alert("제목을 입력해주세요.");
            return;
        }

        const token = localStorage.getItem('token');
        
        const formData = new FormData();
        formData.append('title', title);
        formData.append('content', content); // ✅ 수정된 내용도 전송
        
        if (file) {
            formData.append('image', file);
        }

        try {
            const res = await fetch(`${BOARD_URL}/gallery/${id}`, {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${token}` 
                },
                body: formData
            });

            if (res.ok) {
                alert("수정되었습니다.");
                // 수정 후 상세 페이지로 이동 (경로 확인 필수!)
                navigate(`/gallery/gallerydetail/${id}`); 
            } else {
                const data = await res.json();
                alert(data.message || "수정 실패");
            }
        } catch (err) {
            console.error(err);
            alert("서버 오류가 발생했습니다.");
        }
    };

    return(
        <>
        <Navbar />
        <Banner imageSrc={topImage} title="갤러리 수정" />
        <div className="gallery-container">
                        <input
                            className="gallery-input"
                            type="text"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            placeholder="제목을 입력해 주세요."
                        />
        


                    <div className="gallery-btn-wrap" onClick={triggerFileInput} style={{cursor: 'pointer'}}>
                        <div className="gallery-btn-add">이미지 변경 +</div>
                    </div>
                    <input 
                        type="file" 
                        ref={fileInputRef} 
                        style={{display: 'none'}} 
                        accept="image/*"
                        onChange={handleFileChange}
                    />
     
                    <div className="bot-frame">
                        <img 
                            src={preview ? preview : currentImageUrl} 
                            alt="이미지" 
                            className="main-image"
                        />
                        
                        {preview && (
                            <img 
                                src={X} 
                                alt="변경 취소" 
                                className="remove-icon" 
                                onClick={handleRemoveNewImage}
                                style={{cursor: 'pointer'}}
                            />
                        )}
                    <textarea
                        className="gallery-textarea"
                        value={content} // ✅ 여기에 불러온 내용이 표시됨
                        onChange={(e) => setContent(e.target.value)}
                        placeholder="내용을 입력하세요."
                        rows={6}
                    />
                    
                    
                    </div>


            <div className="admin">
                <div className="admin-box" onClick={handleUpdate} style={{cursor: 'pointer'}}>
                    <div className="admin-text">수정 완료</div>
                </div>
                <div 
                    className="admin-box" 
                    onClick={() => navigate(-1)} 
                     style={{cursor: 'pointer', background: '#fff',marginLeft: '1vw'}}
                >
                    <div className="admin-text" style={{color:'#5a5a5aff'}}>취소</div>
                </div>
            </div>
        </div>
        

        <Footer />

        </>
    );
}